import {ButtonGroup} from 'platform/components';
import {Box, VStack} from 'platform/foundation';

import {isNil} from 'ramda';

import {useGetRentalOrderQuery} from '@dms/api/rental';
import i18n from '@dms/i18n';
import {rentalOrderRoutes, testIds} from '@dms/routes';
import {type DmsDataGridProps, Main} from '@dms/shared';

import {composePath, useNavigate, useRequiredParams} from 'shared/web';

import {RentInspections} from '../Inspections/RentInspections';
import {RentVehicleForm} from '../RentVehicleForm/RentVehicleForm';
import {VehicleRentalDocuments} from '../VehicleRentalDocuments/VehicleRentalDocuments';
import {useRentInspectionActions} from './hooks/useRentInspectionActions';

export function RentVehicle(props: Pick<DmsDataGridProps, 'maximization'>) {
  const {id: rentalOrderId} = useRequiredParams();
  const {data: rentalOrder} = useGetRentalOrderQuery({rentalOrderId});

  const navigate = useNavigate();

  const actions = useRentInspectionActions();

  return (
    <VStack width="100%">
      <Main
        actions={actions}
        tabs={[
          {
            href: composePath(rentalOrderRoutes.rentVehicle, {
              params: {id: rentalOrderId},
            }),
            title: i18n.t('general.labels.basicInformation'),
            id: 'rent-vehicle-form',
            content: (
              <VStack spacing={4}>
                <RentVehicleForm />
                <VehicleRentalDocuments maximization={props.maximization} />
              </VStack>
            ),
          },
          {
            href: composePath(rentalOrderRoutes.rentVehicleInspections, {
              params: {id: rentalOrderId},
            }),
            content: <RentInspections />,
            id: 'rent-vehicle-inspections',
            title: i18n.t('entity.vehicle.labels.inspections'),
            'data-testid': testIds.rentalOrder.rentVehicle('navigation-inspections'),
          },
        ]}
      />

      <Box padding={[2, 4]}>
        <ButtonGroup
          align="right"
          buttons={[
            {
              variant: 'outlined',
              title: i18n.t('general.actions.back'),
              onClick: () =>
                navigate(
                  composePath(rentalOrderRoutes.vehicleAndCustomer, {params: {id: rentalOrderId}})
                ),
            },
            {
              variant: 'outlined',
              title: i18n.t('general.actions.continue'),
              isDisabled: rentalOrder?.state === 'reserved' || isNil(rentalOrder?.rentVehicle),
              onClick: () =>
                navigate(
                  composePath(rentalOrderRoutes.returnVehicle, {params: {id: rentalOrderId}})
                ),
            },
          ]}
        />
      </Box>
    </VStack>
  );
}
